import axios from 'axios'

/**
 * 礼物相关API
 * 处理与礼物赠送相关的接口请求
 */
export default {
  /**
   * 获取用户好友列表
   * @param {number} userId - 当前用户ID
   * @returns {Promise} - 好友列表数据
   */
  getFriendsList(userId) {
    return axios({
      url: '/message/api/v1/friend/list',
      method: 'get',
      params: { userId }
    })
  },

  /**
   * 发送礼物请求
   * @param {Object} params - 礼物请求参数
   * @param {number} params.senderId - 发送者ID
   * @param {number} params.receiverId - 接收者ID
   * @param {number} params.productId - 商品ID
   * @returns {Promise} - 请求结果
   */
  sendGiftRequest(params) {
    return axios({
      url: '/product-service/api/gift/request',
      method: 'post',
      data: params
    })
  },

  /**
   * 查询礼物请求列表
   * @param {Object} params - 检查参数
   * @param {number} params.userId - 接收者或发送者ID
   * @param {number} params.status - 状态（0-待确认/1-已接受/2-已拒绝）
   * @returns {Promise} - 礼物状态数据status（是否接受等）
   */
  list(params) {
    return axios({
      url: '/product-service/api/gift/list',
      method: 'get',
      params: params
    })
  },

  /**
   * 处理礼物请求（接受/拒绝）
   * @param {Object} params - 处理参数
   * @param {number} params.requestId - 礼物请求ID
   * @param {number} params.receiverId - 接收者ID
   * @param {boolean} params.accepted - 是否接受
   * @returns {Promise} - 处理结果
   */
handleGiftRequest(params) {
  return axios({
    url: '/product-service/api/gift/handle',
    method: 'post',
    params: params  // 正确：参数会作为查询字符串拼接到URL
  })
}
}